import { motion } from "framer-motion";
import Button from "./Button";

export default function ContactButton({
  children = "Let's talk",
  variant = "primary",
  size = "large",
  className,
  href,
}: {
  children?: React.ReactNode;
  className?: string;
  variant?: "primary" | "secondary";
  size?: "small" | "large";
  href?: string;
}) {
  return (
    <motion.a
      href={href || "mailto:hello@sweep.studio"}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: "spring", stiffness: 400, damping: 10 }}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Button variant={variant} size={size} className={className}>
        {children}
      </Button>
    </motion.a>
  );
}
